import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import 'hammerjs';
import { Circles } from 'react-loader-spinner';
import axios from '../common/axios';
import { Box,Typography } from '@mui/material';
import ProgressChartWithTitle from './common/schartwithTitle';
import { useRecoilState } from 'recoil';
import { chartDataState } from '../recoil/atom';
import dayjs from 'dayjs';


const PartProgressChart = ({ height, width, criteriaDate }) => {
    const [chartData, setChartData] = useRecoilState(chartDataState);
    const [max, setMax] = useState(0);
    const [loading, setLoading] = useState(true);
    const sumWeightValue = _.sumBy(chartData.filter(v=>v.monthweek ==="M"), 'PV');

  


    const groupData_W = 
    _(chartData.filter(v=>v.monthweek ==="W"))
      .groupBy('date')
      .map((objs, key) => ({
        date:key,
        'EV': (_.sumBy(objs, "EV")/sumWeightValue)*100,
        'PV': (_.sumBy(objs, "PV")/sumWeightValue)*100,
      }))
      .value();
  

      const groupData_M = 
      _(chartData.filter(v=>v.monthweek ==="M"))
        .groupBy('date')
        .map((objs, key) => ({
          date:key,
          'EV': (_.sumBy(objs, "EV")/sumWeightValue)*100,
          'PV': (_.sumBy(objs, "PV")/sumWeightValue)*100,
        }))
        .value();
    

    const calculateCumulativeValues = (data) => {
      let cumulativePV = 0;
      let cumulativeEV = 0;
      return data.map((item) => {
        cumulativePV += item.PV;
        cumulativeEV += item.EV || 0;
        return {
          ...item,
          cumulativePV,
          cumulativeEV,
        };
      });
    };
  
    const transformedDataWithCumulative = {
        weekProgress: calculateCumulativeValues(groupData_W).map(item => {
            const itemDate = dayjs(item.date, 'YY년 WW주');
            if (itemDate.isAfter(criteriaDate)) {
              return { ...item, cumulativeEV: null };
            }
            return item;
          }),
        monthProgress:  calculateCumulativeValues(groupData_M).map(item => {
            const itemDate = dayjs(item.date, 'YY년 MM월');
            if (itemDate.isAfter(criteriaDate)) {
              return { ...item, cumulativeEV: null };
            }
            return item;
          }),
       
      };


    // if (loading) {
    //   return <Circles color="#00BFFF" height={80} width={80} />;
    // }

        return (
            <ProgressChartWithTitle
                height={height}
                width={width}
                title="Progress"
                chartData={transformedDataWithCumulative}
                unit="%"
                chart_id="partprogress"
                maxYaxis={110}
                colors={['#FEAE65','#48CAE4']}

            />
        );
  
};


export default PartProgressChart

